export const webSocketUrl = 'kd194z58ih.execute-api.us-east-1.amazonaws.com';
export const messagingWsUrl = '348vddxzb2.execute-api.us-east-1.amazonaws.com';
export const environment = {
  production: false,
  WSS_ENDPOINT: `wss://${webSocketUrl}/prod`,
  MESSAGING_WS_ENDPOINT: `wss://${messagingWsUrl}/prod`,
  REGION: 'us-east-1',
  IDENTITY_POOL_ID: 'us-east-1:6fbfc34f-3017-40ad-b8a5-d515e56493a9',
  USER_POOL_APP_CLIENT_ID: '6buto4lvjajpf55fonjeuk9pu3',
  USER_POOL_ID: 'us-east-1_IvoF6mHg0',
  REST_API: 'https://xhol89azxb.execute-api.us-east-1.amazonaws.com/prod/',
  ACTIVE_PLAYERS_API: 'https://f6t8nfing2.execute-api.us-east-1.amazonaws.com/prod',
  AWS_AUDIO_S3_BUCKET: 'st-audio-bucket',
};